import { render, staticRenderFns } from "./ConfirmMessageShareCampaign.vue?vue&type=template&id=498fa624&scoped=true&"
import script from "./ConfirmMessageShareCampaign.vue?vue&type=script&lang=js&"
export * from "./ConfirmMessageShareCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498fa624",
  null
  
)

export default component.exports